import React, { useEffect } from "react";
import Task, { taskTypes } from "components/Task";

const FoldersContent = () => {
  useEffect(() => {
    if (window.Application !== undefined) {
      window.Application.Dropzone.setupDropzone();
    }
  }, []);

  return (
    <div className="folders_home" data-testid="folders-home">
      <span className="folders_home__title">Get Started</span>
      <span className="folders_home__description">
        Start by uploading your PDF, Word or Excel files for analysis
      </span>
      <div className="folders_home__task_list">
        <Task type={taskTypes.createFolder} />
        <Task type={taskTypes.uploadDocuments} args={{ chooseFolder: true }} />
      </div>
    </div>
  );
};

export default FoldersContent;
